import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .gerry-layout {
      grid-template-rows: minmax(0, auto) minmax(0, auto);
      max-width: 100%;
    }

    .text-right.text-big-panel,
    .text-left.text-big-panel,
    .text-right.text-small-panel,
    .text-left.text-small-panel {
      grid-column: 2 / 8;
      grid-row: 1;
    }

    .image-left.image-small-panel,
    .image-right.image-small-panel,
    .image-left.image-big-panel,
    .image-right.image-big-panel {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    h3 {
      font-weight: 400;
      font-size: 1.25em;
      letter-spacing: -1.12px;
      line-height: 1.25em;
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .text-wrapper > .text {
      padding: calc(20em / var(--default-rem-px-count));
      text-wrap: balance;
    }

    .image-wrapper {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .image-wrapper {
      height: 100%;
      display: flex;
      justify-content: center;
    }

    .image-wrapper img {
      max-width: 100%;
      object-fit: cover;
      object-position: center;
    }

    @media (min-width: 600px) {
      h3 {
        font-size: 1.25em;
      }

      .gerry-layout {
        grid-template-rows: minmax(0, auto);
      }

      .text-wrapper > .text {
        padding: calc(20em / var(--default-rem-px-count));
      }

      .image-left.image-small-panel,
      .text-left.text-small-panel {
        grid-column: 2 / 6;
        grid-row: 1;
      }

      .image-right.image-small-panel,
      .text-right.text-small-panel {
        grid-column: 10 / 14;
        grid-row: 1;
      }

      .image-left.image-big-panel,
      .text-left.text-big-panel {
        grid-column: 2 / 10;
        grid-row: 1;
      }

      .image-right.image-big-panel,
      .text-right.text-big-panel {
        grid-column: 6 / 14;
        grid-row: 1;
      }
    }

    @media (min-width: 1024px) {
      h3 {
        font-size: 1.75em;
      }
    }
  `,
];
